<template>
    <CheckoutFormDialog v-if="!!store.getters['lite/checkoutDialog']?.visible" />
    <CheckoutLoginDialog v-if="!!store.getters['lite/checkoutLoginDialogVisible']" />
</template>
  
<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import CheckoutFormDialog from "../lites/CheckoutFormDialog.vue"
import CheckoutLoginDialog from "../lites/CheckoutLoginDialog.vue"
import parsePhoneNumber from "libphonenumber-js";
import { cloneDeep } from "lodash"

const props = defineProps({
    storeData: Object,
    dealerData: Object,
    userData: Object,
    isSubscribe: Number,
})

const store = useStore()

onMounted(() => {
    store.commit('lite/setStoreData', props.storeData);
    store.commit('lite/setDealerData', props.dealerData);
    store.commit('lite/setIsSubscribe', props.isSubscribe);
    // 特殊處理 user.mobile E164 to local number
    const userData = cloneDeep(props.userData);
    // if (userData?.mobile && userData?.mobile?.startsWith("+")) {
    //     const phoneNumber = parsePhoneNumber(userData.mobile);
    //     if (['TW', 'MY'].includes(phoneNumber.country)) {
    //         userData.mobile = `0${phoneNumber.nationalNumber}`
    //     } else {
    //         userData.mobile = `${phoneNumber.nationalNumber}`
    //     }
    // }
    store.commit('lite/setUserData', userData);
    // 登入後自動開啟「開始結帳」
    if (window.localStorage.getItem('liteAutoOpenCheckoutDialogLogonCallback')) {
        localStorage.removeItem('liteAutoOpenCheckoutDialogLogonCallback');
        if (userData?.id) {
            store.dispatch('lite/openCheckoutDialog');
        }
    }
})

</script>
  